export default "__VITE_ASSET__CoSJWBTF__"